import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Makes API calls
 */
const vehicleMakeService = {
  /**
   * Get all vehicle makes with pagination and filters
   */
  getAllMakes: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        type = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        type,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_MAKES.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.getAllMakes'));
    }
  },

  /**
   * Get a single vehicle make by ID
   */
  getMakeById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_MAKES.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.getMakeById'));
    }
  },

  /**
   * Create a new vehicle make
   * Accepts JSON or FormData (file field: image)
   */
  createMake: async (makeData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_MAKES.CREATE, makeData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.createMake'));
    }
  },

  /**
   * Update a vehicle make
   * Accepts JSON or FormData (file field: image)
   */
  updateMake: async (id, makeData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_MAKES.UPDATE(id), makeData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.updateMake'));
    }
  },

  /**
   * Delete a vehicle make
   */
  deleteMake: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_MAKES.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.deleteMake'));
    }
  },

  /**
   * Delete multiple vehicle makes
   */
  deleteMultipleMakes: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_MAKES.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.deleteMultipleMakes'));
    }
  },

  /**
   * Toggle make status
   */
  toggleMakeStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_MAKES.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleMakeService.toggleMakeStatus'));
    }
  },
};

export default vehicleMakeService;
